import { removeNullValuesFromObject } from './common';
export function getSearchParamsFromRequestConfigs(requestConfigs) {
    const { query = '', filterValue, filterName, ...rest } = requestConfigs;
    const searchParams = removeNullValuesFromObject(rest);
    return { query, searchParams };
}
export function getBrowseParamsFromRequestConfigs(requestConfigs) {
    const { query, filterValue = '', filterName = '', ...queryParams } = requestConfigs;
    return { filterName, filterValue, queryParams: removeNullValuesFromObject(queryParams) };
}
export function checkIsSearchPage(requestConfigs) {
    const { query } = getSearchParamsFromRequestConfigs(requestConfigs);
    return !!query;
}
export function checkIsBrowsePage(requestConfigs) {
    const { filterName, filterValue } = getBrowseParamsFromRequestConfigs(requestConfigs);
    return !!filterName && !!filterValue;
}
export function getPageType(requestConfigs) {
    if (checkIsSearchPage(requestConfigs)) {
        return 'search';
    }
    if (checkIsBrowsePage(requestConfigs)) {
        return 'browse';
    }
    return 'unknown';
}
